import React,{useReducer} from 'react';
import '../../App.css';
import Header from '../MainComponents/Header'
import Footer from '../MainComponents/Footer';
import {reducer as reducerAuth,initialState as initialStateAuth ,AuthProvider} from './Contexts/AuthContext'
import {reducer as reducerCart,initialState as initialStateCart,CartProvider} from './Contexts/CartContext'
import {reducer as reducerLoading,initialState as initialStateLoading,LoadingProvider} from './Contexts/LoadingContext'
import {MenuProvider,initialState, MenuReducer} from '../../components/Context/MenuContext';
import LoadingBar from 'react-top-loading-bar';
import Menu from '../MainComponents/Menu'
import MenuShop from './MenuShop';
import TitoloPagine from './TitoloPagine';

function AppShopProfile(props) {
  const [state, dispatch] = useReducer(MenuReducer, initialState)
  const [AuthState, AuthDispatch] = React.useReducer(reducerAuth, initialStateAuth);
  const [CartState, CartDispatch] = React.useReducer(reducerCart, initialStateCart);
  const [LoadingState, LoadingDispatch] = React.useReducer(reducerLoading, initialStateLoading);
  return (
    <div className="App container-fluid">
      <AuthProvider value={{AuthState, AuthDispatch}}>
      <CartProvider value={{CartState,CartDispatch}}>
      <LoadingProvider value={{LoadingState,LoadingDispatch}}>
        <div id="header-container" className="bottom-line">
          <Header></Header>
        </div>
        <div className="contenitore container">
          <LoadingBar progress={LoadingState.progress} height={LoadingState.height} color={LoadingState.color}></LoadingBar>
          <div className="row">
            <div className="col-lg-3 col-md-3 d-none d-md-block">
              <div className="col-12" >
                <TitoloPagine size={4} title={"IL TUO ACCOUNT"}></TitoloPagine>
                <div style={{textAlign:"left"}}>
                  <MenuShop border={false} tipomenu={"menu-left-side"}></MenuShop>
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
              {props.children}
            </div>
          </div>
        </div>
        <Footer></Footer>
        </LoadingProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default AppShopProfile;
